module.exports = __webpack_public_path__ + "static/media/Peers.e436e0fa.svg";